import { navigate } from '@reach/router';
import IconClose from 'assets/svg/icons/close.inline.svg';
import IconButton from 'components/Atoms/IconButton';
import { routes } from 'constants/routes';
import { updateCookiePolicy } from 'ducks/app';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { css, styled } from 'twin.macro';

const animationDuration = 500;

const AnimatedTranslateDiv = styled.div`
	transition: transform ${animationDuration}ms;
	
  transform: translate(0px, 0px);
  ${({ isClosing }) => isClosing && css`
	  transform: translate(0px, 200px);
	`}
`;

/**
 * @return {null}
*/
export default function CookiePolicy() {
	const { isCookiePolicy } = useSelector(state => state.app);
	const dispatch = useDispatch();

	const [isClosing, setClosing] = useState(false);
	const [isShowing, setShowing] = useState(false);

	useEffect(() => {
		setTimeout(() => setShowing(true), 4000);
	}, []);

	const redirectToCookies = () => {
		navigate(routes.REGULATIONS);
	};

	const handleRemove = () => {
		dispatch(updateCookiePolicy(false));
	};

	const handleClose = () => {
		setTimeout(handleRemove, animationDuration);
		setClosing(true);
	};

	if(!isCookiePolicy || !isShowing) return null;

	return (
		<AnimatedTranslateDiv className='fixed w-full bottom-0 mb-nav pb-05 mx-auto z-max' isClosing={isClosing}>
			<div className='w-19/20 mx-auto pl-10 pr-05 pt-05 pb-03 flex justify-between items-center bg-grey-E opacity-90'>
				<div className='flex flex-col items-start justify-center'>
					<p className='text-12'>Polityka plików cookie</p>
					<div className='text-07'>
						Korzystając z naszej strony internetowej i naszych usług, wyrażasz zgodę na korzystanie z plików cookie z naszą
						&nbsp;<p onClick={redirectToCookies} className='contents underline'>Polityką plików cookie</p>
					</div>
				</div>

				<IconButton tw='fill-current text-dark p-03 h-24' Component={IconClose} onClick={handleClose} size='1.8rem' />
			</div>
		</AnimatedTranslateDiv>
	);
}
